import Create from "./Create";
import Update from "./Update";
import Search from "./Search";
import Filter from "./Filter";
import Body from "./Body";

const Components = {
  Create,
  Update,
  Search,
  Filter,
  Body,
};

export default Components;
